<h2 mat-dialog-title>{{ aboutTitle }}</h2>
<mat-dialog-content>
  <div class="about-content">
    @if (loading) {
      <div class="loading-container">
        <mat-spinner diameter="30"></mat-spinner>
        <p>{{ loadingLabel }}</p>
      </div>
    }

    @if (error) {
      <div class="error-container">
        <p>{{ errorMessage }}</p>
      </div>
    }

    @if (!loading && !error) {
      <div>
        <div class="version-info">
          <p><strong>{{ APP_NAME }} {{ versionLabel }} {{ versionInfo?.version || unknownVersion }}</strong><br/>
          {{ COPYRIGHT }}
        </p>
          <p>{{ privacyPolicyPrefix }} <a
            href="https://www.interverbumtech.com/privacy-policy" target="_blank">{{ privacyPolicyLink }}</a>.</p>
      </div>
      <div class="license-section">
        <h5>{{ frontendLibrariesLabel }}</h5>
        <pub-license-display [licenses]="versionInfo?.frontendLicenses"></pub-license-display>
      </div>
      <div class="license-section">
        <h5>{{ backendLibrariesLabel }}</h5>
        <pub-license-display [licenses]="versionInfo?.backendLicenses"></pub-license-display>
      </div>
    </div>
  }
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-raised-button (click)="close()">{{ closeLabel }}</button>
</mat-dialog-actions>
